import SingleCard from '../../components/Cards/SingleCard';
import styles from './singlelist.module.scss';
import { useTranslation } from 'react-i18next';

const SingleList = () => {
	const [t] = useTranslation();
	return (
		<section id="singles" className={styles.container}>
			<div className={styles.content_wrapper}>
			<div className={styles.text_wrapper}>
					<h5>
						<b>{t('single.container.braveUp')}</b>
					</h5>
					<h1 className={styles.title}>
						{t('section.solution.title')}
					</h1>
				</div>
				<div className={styles.card_list}>
					<SingleCard
					title={t('single.single001.title')}
					url={t('single.single001.link')}
					/>

					<SingleCard
					title={t('single.single002.title')}
					url={t('single.single002.link')}
					/>

					<SingleCard
					title={t('single.single003.title')}
					url={t('single.single003.link')}
					/>

					<SingleCard
					title={t('single.single004.title')}
					url={t('single.single004.link')}
					/>

					<SingleCard
					title={t('single.single005.title')}
					url={t('single.single005.link')}
					/>

					<SingleCard
					title={t('single.single006.title')}
					url={t('single.single006.link')}
					/>

					<SingleCard
					title={t('single.single007.title')}
					url={t('single.single007.link')}
					/>
				</div>
				

			</div>
		</section>
	);
};

export default SingleList;
